export default __webpack_public_path__ + "static/media/gestational_diabetes2.1ce4d2ca.jpg";